module.exports = __webpack_public_path__ + "img/golden-arrows-logo-icon.ed95ff89.png";